const footer = () => {
  return (
    <div className='col-12 text-center footer'>
      <br />
      <small>Made with React and Redux - 2021</small>
      <br />
      <br />
    </div>
  )
}

export default footer
